import type { PixiPaymentMethod } from "../../../hooks/usePixiWizardState";
import { CardForm } from "../CardForm";
import { PaymentMethodPicker } from "../PaymentMethodPicker";
import { GuidanceNotice } from "./GuidanceNotice";
import { InvoiceNotice } from "./InvoiceNotice";
import { SectionCard } from "./SectionCard";

export interface PaymentSectionProps {
  paymentMethod: PixiPaymentMethod;
  onSelectMethod: (method: PixiPaymentMethod) => void;
  /** Reports the Stripe paymentMethod id once the card is tokenized, else null. */
  onCardPaymentMethodChange: (id: string | null) => void;
}

/**
 * Payment method picker plus the selected method's body: the credit-card fields
 * (Credit card) or a guidance notice (Invoice, PayPal, Direct Debit). The Stripe
 * `Elements` provider is owned by the parent step, so this stays a presentational
 * section.
 */
export function PaymentSection({
  paymentMethod,
  onSelectMethod,
  onCardPaymentMethodChange,
}: PaymentSectionProps) {
  return (
    <SectionCard testId="payment-card">
      <PaymentMethodPicker selected={paymentMethod} onSelect={onSelectMethod} />
      {paymentMethod === "credit_card" && (
        <CardForm onPaymentMethodChange={onCardPaymentMethodChange} />
      )}
      {paymentMethod === "invoice" && <InvoiceNotice />}
      {paymentMethod === "paypal" && (
        <GuidanceNotice
          testId="paypal-notice"
          messageId="pixi_wizard.payment_shipping.paypal_notice"
          defaultMessage="You'll complete payment with PayPal when you place your order."
        />
      )}
      {paymentMethod === "direct_debit" && (
        <GuidanceNotice
          testId="direct-debit-notice"
          messageId="pixi_wizard.payment_shipping.direct_debit_notice"
          defaultMessage="Direct Debit is set up when you place your order."
        />
      )}
    </SectionCard>
  );
}
